import Container from '@components/ui/layout/Container'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading } from '@components/ui/typography'
import { FadeInChild } from '@components/_home/FadeInChild'
import React, { FC } from 'react'
import { AboutUsSingleton } from '__generated__/sanity'
import { Block } from './Block'
import * as styles from './styles'

type UspBlocksProps = AboutUsSingleton['fields']['uspBlocks']

export const UspBlocks: FC<UspBlocksProps> = ({ uspBlockTitle, uspBlockBlocks }) => {
  const columnCount = uspBlockBlocks.length % 3 === 0 ? 3 : 2

  return (
    <FadeInChild>
      <SmallContainer as="div">
        <Heading variant="h3" as="h3" mb="0">
          {uspBlockTitle}
        </Heading>
      </SmallContainer>
      <Container className={styles.grid} as="ul" data-columns={columnCount}>
        {uspBlockBlocks.map((block, index) => (
          <Block
            title={block.uspBlockBlockTitle}
            description={block.uspBlockBlockDescription}
            index={index}
            key={index}
          />
        ))}
      </Container>
    </FadeInChild>
  )
}
